module.exports = __webpack_public_path__ + "../resources/img/storebadge_en.2928664f.svg";